import React, { createContext, useState } from "react";
import { noop } from "@catchoftheday/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var WishlistContext = /*#__PURE__*/createContext({
  deletedWishlistProductId: null,
  setDeletedWishlistProductId: noop
});
export var WishlistContextProvider = function WishlistContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      deletedWishlistProductId = _useState[0],
      setDeletedWishlistProductId = _useState[1];

  return ___EmotionJSX(WishlistContext.Provider, {
    value: {
      deletedWishlistProductId: deletedWishlistProductId,
      setDeletedWishlistProductId: setDeletedWishlistProductId
    }
  }, children);
};